import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9bd0c940"
import script from "./index.vue?vue&type=script&setup=true&lang=ts"
export * from "./index.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Banner: require('/vercel/path0/components/Banner.vue').default,Nav: require('/vercel/path0/components/Nav.vue').default,Header: require('/vercel/path0/components/Header.vue').default,SideBar: require('/vercel/path0/components/SideBar.vue').default,Promo: require('/vercel/path0/components/Promo.vue').default,LearningObjectives: require('/vercel/path0/components/LearningObjectives.vue').default,RelatedTopics: require('/vercel/path0/components/RelatedTopics.vue').default,CourseIncludes: require('/vercel/path0/components/CourseIncludes.vue').default,TopCompanies: require('/vercel/path0/components/TopCompanies.vue').default,CourseContentDetail: require('/vercel/path0/components/CourseContentDetail.vue').default,FeaturedReview: require('/vercel/path0/components/FeaturedReview.vue').default,StudentsAlsoBought: require('/vercel/path0/components/StudentsAlsoBought.vue').default,BroughtTogether: require('/vercel/path0/components/BroughtTogether.vue').default,Instructor: require('/vercel/path0/components/Instructor.vue').default,MoreCourseByJoseph: require('/vercel/path0/components/MoreCourseByJoseph.vue').default,Footer: require('/vercel/path0/components/Footer.vue').default,Footer: require('/vercel/path0/components/Footer.vue').default})
